module.exports = __webpack_public_path__ + "img/BlinkArt_Sword14_Blue.fb9453b3.png";